(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerMedia = window.matchMedia('(max-width: 990px)');
      this.onHeaderResize = this.setHeaderHeight.bind(this);
      this.headerMedia.addEventListener('change', this.onHeaderResize);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerMedia?.removeEventListener('change', this.onHeaderResize);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-flotantes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editable-review-popup')) {
    customElements.define('editable-review-popup', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.index = -1;
        this.closed = false;
        this.editor = !!window.Shopify?.designMode;
        this.selected = false;
        this.visible = false;
        this.hovering = false;
        this.focused = false;
        this.hidden = true;
        if (!this.cards.length || (this.dataset.enabled !== 'true' && !this.editor)) return;
        this.addEventListener('click', e => {
          if (!e.target.closest('.rp-close')) return;
          // Cerrar solo oculta la tarjeta y reinicia la pausa entre reseñas.
          this.closed = false;
          this.selected = false;
          this.hovering = false;
          this.focused = false;
          this.hide();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovering = true; this.clear(); }, options);
        this.addEventListener('mouseleave', () => { this.hovering = false; this.resume(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.clear(); }, options);
        this.addEventListener('focusout', e => {
          if (this.contains(e.relatedTarget)) return;
          this.focused = false; this.resume();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.clear(); else this.resume();
        }, options);
        document.addEventListener('shopify:block:select', e => {
          const i = this.cards.findIndex(c => c.dataset.review === e.detail?.blockId);
          if (i < 0) return;
          this.clear(); this.selected = true; this.closed = false; this.show(i);
        }, options);
        document.addEventListener('shopify:block:deselect', e => {
          if (!this.cards.some(c => c.dataset.review === e.detail?.blockId)) return;
          this.selected = false; this.resume();
        }, options);
        if (this.editor) this.show(0);
        else this.schedule(() => this.show(), Number(this.dataset.start));
      }
      clear() { clearTimeout(this.timer); }
      schedule(fn, seconds) {
        this.clear();
        if (!this.closed && !document.hidden && !this.selected && !this.hovering && !this.focused)
          this.timer = setTimeout(fn, seconds * 1000);
      }
      show(forced) {
        if (!this.isConnected || this.closed) return;
        this.clear();
        let next = forced;
        if (next === undefined) {
          if (this.dataset.random === 'true' && this.cards.length > 1) {
            const available = this.cards.map((_, i) => i).filter(i => i !== this.index);
            next = available[Math.floor(Math.random() * available.length)];
          } else next = (this.index + 1) % this.cards.length;
        }
        this.cards.forEach((c, i) => { c.hidden = i !== next; c.classList.remove('rp-enter'); });
        this.index = next; this.hidden = false; this.visible = true;
        this.cards[next].classList.add('rp-enter');
        this.schedule(() => this.hide(), Number(this.dataset.duration));
      }
      hide() {
        this.cards.forEach(c => { c.hidden = true; });
        this.hidden = true; this.visible = false;
        this.schedule(() => this.show(), Number(this.dataset.gap));
      }
      resume() {
        this.schedule(() => this.visible ? this.hide() : this.show(), this.visible ? Number(this.dataset.duration) : Number(this.dataset.gap));
      }
      disconnectedCallback() { this.clear(); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
